import { gql } from "@apollo/client";

const PROFILE_VIDEOS = gql`
  query profileQuery(
    $id: ID!
    $take: Int
    $cursor: ID
    $filters: ProfileMediaFilters
  ) {
    profile(id: $id) {
      id
      videosCount
      media(type: "VIDEO", take: $take, cursor: $cursor, filters: $filters) {
        id
        createdAt
        type
        subtype
        isExternal
        filename
        public
        aspectRatio
        clapCount
        isClapped
      }
    }
  }
`;

export default PROFILE_VIDEOS;
